import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Popover, PopoverBody, PopoverHeader } from 'reactstrap';
import { useCheckboxCookie } from '../../form_cookie';

function SectionPaid({
                               paid,
                               requestType,
                               setPaid,
                               editMode,
                             }) {
  const [popoverOpen, setPopoverOpen] = useState(false);
  const [feeBased, setFeeBased] = useCheckboxCookie('fee-based-opportunity', false);

  if (requestType === 'story_ideas') {
    return null;
  }

  const togglePopover = () => setPopoverOpen(!popoverOpen);

  const handleChange = (e) => {
    const value = e.target.checked;

    if (editMode && setPaid !== undefined) {
      setPaid(value);
    } else {
      setFeeBased(value);
    }
  };

  return (
    <div className="mb-3">
      <label className="form-check ps-0" style={{ display: 'inline' }}>
        <input
          id="paid"
          type="checkbox"
          className="me-2"
          defaultChecked={editMode ? paid : feeBased}
          onInput={(e) => handleChange(e)}
        />
        <span htmlFor="paid">
          This is a fee-based opportunity
        </span>
        <small>
          <button
            id="paidPopover"
            type="button"
            className="btn btn-link ps-0 pt-0 ms-1"
          >
            <i className="fa-solid fa-circle-question" />
          </button>

          <Popover
            placement="auto"
            isOpen={popoverOpen}
            target="paidPopover"
            toggle={togglePopover}
          >
            <PopoverHeader>What does this mean?</PopoverHeader>
            <PopoverBody>
              Please be sure to indicate any fee-based editorial placement opportunities when posting.
              This transparency helps maintain the trust and integrity of our community.
              Failure to do so may result in account restrictions.
            </PopoverBody>
          </Popover>
        </small>
      </label>
    </div>
  );
}

SectionPaid.propTypes = {
  paid: PropTypes.bool,
  requestType: PropTypes.string,
  setPaid: PropTypes.func,
  editMode: PropTypes.bool,
};

SectionPaid.defaultProps = {
  paid: undefined,
  requestType: undefined,
  setPaid: undefined,
  editMode: false,
};

export default SectionPaid;
